import type { ProgramsProgramCohortModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class ProgramsProgramCohortMessagesIndexRoute extends Route {
  @service declare router: RouterService;

  redirect() {
    const parentModel = this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;

    void this.router.transitionTo(
      'programs.program.cohort.messages.category',
      parentModel.program_id,
      parentModel.cohort_id,
      'announcement'
    );
  }
}
